import * as C from "../constants/actionType";

const initialState = {
    show: false
};

export default function showPreloader(state = initialState, action) {
    if (action.type === C.SHOW_PRELOADER) {
        return { show: action.payload };
    } else {
        return state;
    }

}